module.exports = __webpack_public_path__ + "img/GP.24fd396f.svg";